/**
 * Heatmap Service
 * API-anrop för heatmap-data
 */

import api from '../api/client';

export interface HeatmapPoint {
  lat: number;
  lng: number;
  intensity?: number;
  count?: number; // Antal händelser/punkter för denna plats
}

export interface HeatmapData {
  points: HeatmapPoint[];
  tripCount: number;
  mode: string;
}

export interface HeatmapParams {
  vehicleIds?: string | 'all';
  from: string;
  to: string;
  mode?: 'all' | 'overspeed' | 'idling' | 'parking' | 'eco' | 'timepattern' | 'geofence' | 'incidents' | 'charging' | 'riskscore';
  timePattern?: 'all' | 'morning' | 'day' | 'evening' | 'night';
}

class HeatmapService {
  /**
   * Hämta heatmap-punkter
   */
  async getHeatmapPoints(params: HeatmapParams): Promise<HeatmapData> {
    const queryParams = new URLSearchParams();
    
    if (params.vehicleIds) {
      queryParams.append('vehicleIds', params.vehicleIds);
    }
    queryParams.append('from', params.from);
    queryParams.append('to', params.to);
    if (params.mode) {
      queryParams.append('mode', params.mode);
    }
    if (params.timePattern) {
      queryParams.append('timePattern', params.timePattern);
    }

    const response = await api.get<{ success: boolean; data: HeatmapData }>(
      `/api/heatmap/points?${queryParams.toString()}`
    );

    if (!response.data.success) {
      throw new Error('Failed to fetch heatmap data');
    }

    return response.data.data;
  }

  /**
   * Hämta hastighetsöverträdelser
   */
  async getOverspeedPoints(params: Omit<HeatmapParams, 'mode'>): Promise<HeatmapData> {
    return this.getHeatmapPoints({ ...params, mode: 'overspeed' });
  }

  /**
   * Hämta data för specifik bil
   */
  async getVehicleHeatmap(vehicleId: string, params: Omit<HeatmapParams, 'vehicleIds'>): Promise<HeatmapData> {
    return this.getHeatmapPoints({ ...params, vehicleIds: vehicleId });
  }
}

export const heatmapService = new HeatmapService();
export default heatmapService;

